import React, { useEffect, useState } from "react";
import './css/Sidebar.css';
// import apps from '../../assets/img/apps.png';
import track from '../../assets/img/track2.png';
import list from '../../assets/img/list.png';
import users from '../../assets/img/users.png';
import truck from '../../assets/img/truck.png';
import lost from '../../assets/img/lost.png'
import logo from '../../assets/img/logo.jpg'

import axios from 'axios';
import config from "../../config";
import { useSelector } from "react-redux";



const Sidebar = ({ onNavItemClick }) => {
    const [selectedNavItem, setSelectedNavItem] = useState(sessionStorage.getItem('selectedNavItem') || "addTrack");
    const [companyLogoUrl, setCompanyLogoUrl] = useState(logo);

    const role = localStorage.getItem('role')
    const name = useSelector(state => state.user.currentUser.name);
    const surname = useSelector(state => state.user.currentUser.surname);
    const phone = useSelector(state => state.user.currentUser.phone);




    

    const handleNavItemClick = (navItem) => {
        setSelectedNavItem(navItem);
        onNavItemClick(navItem);
      };
      
    useEffect(() => {
      const loadCompanyLogo = async () => {
        if (role === 'company_admin' || role === 'filial') {
          try {
            const token = localStorage.getItem('token');
            if (!token) return;

            const { data } = await axios.get(`${config.apiUrl}/api/company/my-company`, {
              headers: { Authorization: `Bearer ${token}` }
            });

            const logoValue = data?.company?.logo;
            if (logoValue) {
              const logoUrl = logoValue.startsWith('http') ? logoValue : `${config.apiUrl}${logoValue}`;
              setCompanyLogoUrl(logoUrl);
            }
          } catch (error) {
            // ignore - fallback to default logo
          }
        }
      };

      const handleCompanyLogoUpdated = (event) => {
        if (!event?.detail) return;
        const logoUrl = event.detail.startsWith('http') ? event.detail : `${config.apiUrl}${event.detail}`;
        setCompanyLogoUrl(logoUrl);
      };

      window.addEventListener('companyLogoUpdated', handleCompanyLogoUpdated);
      loadCompanyLogo();

      return () => {
        window.removeEventListener('companyLogoUpdated', handleCompanyLogoUpdated);
      };
    }, [role]);

    return (
      
       

        <div id="sidebar" className='sidebar'>
           {/* Бургер-меню, видимое только на мобильных устройствах */}
          {/* <div className="burger-menu" onClick={toggleSidebar}>
            <img src={burgerIcon} alt="Меню" />
          </div> */}

        <div className="header-admin">
          <img src={companyLogoUrl} className="logo-admin" alt="" />
          <p>{config.nameCargo}</p>
        </div>

        <div className="navigation-admin">
          {/* Меню для Super Admin */}
        {role === 'super_admin' && (
          <>
            <div className={`nav-link ${selectedNavItem === "statistics" && "nav-active"}`} onClick={() => handleNavItemClick("statistics")}> 
              <img src={track} alt="" className="nav-icon" />
              <h5 className="nav-title">Статистика</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "superadmin-companies" && "nav-active"}`} onClick={() => handleNavItemClick("superadmin-companies")}>
              <img src={users} alt="" className="nav-icon" />
              <h5 className="nav-title">Компании</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "superadmin-users" && "nav-active"}`} onClick={() => handleNavItemClick("superadmin-users")}>
              <img src={list} alt="" className="nav-icon" />
              <h5 className="nav-title">Пользователи</h5>
              <div></div>
            </div>
            <div className={`nav-link ${selectedNavItem === "allUsers" && "nav-active"}`} onClick={() => handleNavItemClick("allUsers")}>
              <img src={users} alt="" className="nav-icon" />
              <h5 className="nav-title">Все пользователи</h5>
              <div></div>
            </div>
          </>
        )}

        {/* Меню для Company Admin */}
        {role === 'company_admin' && (
          <>
            {/* <div className={`nav-link ${selectedNavItem === "company-settings" && "nav-active"}`} onClick={() => handleNavItemClick("company-settings")}>
              <img src={track} alt="" className="nav-icon" />
              <h5 className="nav-title">Настройки компании</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "company-filials" && "nav-active"}`} onClick={() => handleNavItemClick("company-filials")}>
              <img src={users} alt="" className="nav-icon" />
              <h5 className="nav-title">Филиалы</h5>
              <div></div>
            </div> */}
            
            <div className={`nav-link ${selectedNavItem === "addTrack" && "nav-active"}`} onClick={() => handleNavItemClick("addTrack")}>
              <img src={track} alt="" className="nav-icon" />
              <h5 className="nav-title">Добавить трек</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "trackList" && "nav-active"}`} onClick={() => handleNavItemClick("trackList")}>
              <img src={list} alt="" className="nav-icon" />
              <h5 className="nav-title">Список треков</h5>
              <div></div>
            </div>

            <div className={`nav-link ${selectedNavItem === "trackSearch" && "nav-active"}`} onClick={() => handleNavItemClick("trackSearch")}>
              <img src={list} alt="" className="nav-icon" />
              <h5 className="nav-title">Точечный поиск</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "allUsers" && "nav-active"}`} onClick={() => handleNavItemClick("allUsers")}>
              <img src={users} alt="" className="nav-icon" />
              <h5 className="nav-title">Пользователи</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "statistics" && "nav-active"}`} onClick={() => handleNavItemClick("statistics")}>
              <img src={lost} alt="" className="nav-icon" />
              <h5 className="nav-title">Статистика</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "myCargo" && "nav-active"}`} onClick={() => handleNavItemClick("myCargo")}>
              <img src={companyLogoUrl || truck} alt="" className="nav-icon" />
              <h5 className="nav-title">Мой карго</h5>
              <div></div>
            </div>
          </>
        )}

        {/* Меню для Filial (оригинальное) */}
        {role === 'filial' && (
          <>
            <div className={`nav-link ${selectedNavItem === "addTrack" && "nav-active"}`} onClick={() => handleNavItemClick("addTrack")}>
              <img src={track} alt="" className="nav-icon" />
              <h5 className="nav-title">Добавить трек</h5>
              <div></div>
            </div>

            <div className={`nav-link ${selectedNavItem === "allUsers" && "nav-active"}`} onClick={() => handleNavItemClick("allUsers")}>
              <img src={users} alt="" className="nav-icon" />
              <h5 className="nav-title">Все пользователи</h5>
              <div></div>
            </div>
            
            <div className={`nav-link ${selectedNavItem === "trackList" && "nav-active"}`} onClick={() => handleNavItemClick("trackList")}>
              <img src={list} alt="" className="nav-icon" />
              <h5 className="nav-title">Список треков</h5>
              <div></div>
            </div>

            <div className={`nav-link ${selectedNavItem === "trackSearch" && "nav-active"}`} onClick={() => handleNavItemClick("trackSearch")}>
              <img src={list} alt="" className="nav-icon" />
              <h5 className="nav-title">Точечный поиск</h5>
              <div></div>
            </div>

            <div className={`nav-link ${selectedNavItem === "Lost" && "nav-active"}`} onClick={() => handleNavItemClick("Lost")}>
              <img src={lost} alt="" className="nav-icon" />
              <h5 className="nav-title">Потеряшки</h5>
              <div></div>
            </div>
          </>
        )}

         
         
          </div>
          <div className="footer-admin">
            <p>{name + ' ' + surname + '  '+ phone}</p>
            <p></p>
          </div>
  
        
          
      </div>

    )
}

export default Sidebar;